// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,import_extension=none"
// @generated from file aiUnitHourly/aiUnitHourly.proto (package aiUnitHourlyCummulative, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyCummulativeRequest
 */
export type AiUnitHourlyCummulativeRequest = {
/**
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: aiUnitHourlyCummulative.AiUnitHourlyCummulativeRequest.Type type = 3;
 */
type?: AiUnitHourlyCummulativeRequest_Type;
/**
 * @generated from field: aiUnitHourlyCummulative.UserContext user_context = 4;
 */
userContext?: UserContext;
}
;
/**
 * @generated from enum aiUnitHourlyCummulative.AiUnitHourlyCummulativeRequest.Type
 */
export enum AiUnitHourlyCummulativeRequest_Type {
/**
 * @generated from enum value: SUMMARY = 0;
 */
SUMMARY = "SUMMARY",

/**
 * @generated from enum value: COMPONENT = 1;
 */
COMPONENT = "COMPONENT",
}
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyComponentRequest
 */
export type AiUnitHourlyComponentRequest = {
/**
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: aiUnitHourlyCummulative.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlySummaryRequest
 */
export type AiUnitHourlySummaryRequest = {
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyCummulativeResponse
 */
export type AiUnitHourlyCummulativeResponse = {
}
 & (
{ 
/**
 * @generated from field: aiUnitHourlyCummulative.CumulativeHourlyUsageSummaryResponse summary_response = 1;
 */
summaryResponse?: CumulativeHourlyUsageSummaryResponse;
 }
 | 
{ 
/**
 * @generated from field: aiUnitHourlyCummulative.ComponentHourlyUsageResponse component_response = 2;
 */
componentResponse?: ComponentHourlyUsageResponse;
 }
)
;
/**
 * @generated from message aiUnitHourlyCummulative.CumulativeHourlyUsageSummaryResponse
 */
export type CumulativeHourlyUsageSummaryResponse = {
/**
 * @generated from field: map<string, float> data = 1;
 */
data?: { [key: string]: number };
}
;
/**
 * @generated from message aiUnitHourlyCummulative.ComponentHourlyUsageResponse
 */
export type ComponentHourlyUsageResponse = {
/**
 * @generated from field: map<string, aiUnitHourlyCummulative.AIUnitComponentUsage> data = 1;
 */
data?: { [key: string]: AIUnitComponentUsage };
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AIUnitComponentUsage
 */
export type AIUnitComponentUsage = {
/**
 * @generated from field: optional float mlops_deployments = 1;
 */
mlopsDeployments?: number;
/**
 * @generated from field: optional float h2ogpt = 2;
 */
h2ogpt?: number;
/**
 * @generated from field: optional float h2ogpte_playground = 3;
 */
h2ogptePlayground?: number;
/**
 * @generated from field: optional float mlops = 4;
 */
mlops?: number;
/**
 * @generated from field: optional float doc_ai_proxy = 5;
 */
docAiProxy?: number;
/**
 * @generated from field: optional float aiem_workload = 6;
 */
aiemWorkload?: number;
/**
 * @generated from field: optional float appstore = 7;
 */
appstore?: number;
/**
 * @generated from field: optional float steam = 8;
 */
steam?: number;
/**
 * @generated from field: optional float ml_api = 9;
 */
mlApi?: number;
/**
 * @generated from field: optional float rest_scorer = 10;
 */
restScorer?: number;
/**
 * @generated from field: optional float document_ai = 11;
 */
documentAi?: number;
/**
 * @generated from field: optional float notebook_workload = 12;
 */
notebookWorkload?: number;
/**
 * @generated from field: optional float appstore_apps = 13;
 */
appstoreApps?: number;
/**
 * @generated from field: optional float na = 14;
 */
na?: number;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlySummaryResponse
 */
export type AiUnitHourlySummaryResponse = {
/**
 * Contract start date
 *
 * @generated from field: string envStartDate = 1;
 */
envStartDate?: string;
/**
 * Contract end date
 *
 * @generated from field: string envEndDate = 2;
 */
envEndDate?: string;
/**
 * Purchased AI Unit
 *
 * @generated from field: string purchasedAIUnits = 3;
 */
purchasedAIUnits?: string;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyEvent
 */
export type AiUnitHourlyEvent = {
/**
 * YYYY-MM-DD
 *
 * @generated from field: string date = 1;
 */
date?: string;
/**
 * YYYY-MM
 *
 * @generated from field: string month = 2;
 */
month?: string;
/**
 * YYYY
 *
 * @generated from field: string year = 3;
 */
year?: string;
/**
 * Resource
 *
 * @generated from field: string resource = 4;
 */
resource?: string;
/**
 * AI unit count
 *
 * @generated from field: float ai_units = 5;
 */
aiUnits?: number;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitUsageThresholdRequest
 */
export type AiUnitUsageThresholdRequest = {
/**
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * @generated from field: string end_date = 2;
 */
endDate?: string;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitUsageThresholdResponse
 */
export type AiUnitUsageThresholdResponse = {
/**
 * @generated from field: float threshold = 1;
 */
threshold?: number;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyDateRangeRequest
 */
export type AiUnitHourlyDateRangeRequest = {
}
;
/**
 * @generated from message aiUnitHourlyCummulative.AiUnitHourlyDateRangeResponse
 */
export type AiUnitHourlyDateRangeResponse = {
/**
 * @generated from field: string first_date = 1;
 */
firstDate?: string;
/**
 * @generated from field: string last_date = 2;
 */
lastDate?: string;
}
;
/**
 * @generated from message aiUnitHourlyCummulative.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetHourlyAiUnitCummulativeUsage
 */
export const AiUnitHourlyService_GetHourlyAiUnitCummulativeUsage = new RPC<AiUnitHourlyCummulativeRequest,AiUnitHourlyCummulativeResponse>("POST", "/getHourlyAiUnitCummulativeUsage");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetHourlyAiUnitComponentUsage
 */
export const AiUnitHourlyService_GetHourlyAiUnitComponentUsage = new RPC<AiUnitHourlyComponentRequest,ComponentHourlyUsageResponse>("POST", "/getHourlyAiUnitComponentUsage");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetHourlyAiUnitSummary
 */
export const AiUnitHourlyService_GetHourlyAiUnitSummary = new RPC<AiUnitHourlySummaryRequest,AiUnitHourlySummaryResponse>("GET", "/getHourlyAiUnitSummary");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetAiUnitUsageThreshold
 */
export const AiUnitHourlyService_GetAiUnitUsageThreshold = new RPC<AiUnitUsageThresholdRequest,AiUnitUsageThresholdResponse>("GET", "/getAiUnitUsageThreshold");
/**
 * @generated from rpc aiUnitHourlyCummulative.AiUnitHourlyService.GetAiUnitHourlyDateRange
 */
export const AiUnitHourlyService_GetAiUnitHourlyDateRange = new RPC<AiUnitHourlyDateRangeRequest,AiUnitHourlyDateRangeResponse>("GET", "/getAiUnitHourlyDateRange");
